export const SITE = {
  name: 'Nebraska Backyard Living',
  legalName: 'Lee Contracting LLC',
  tagline: 'Custom Outdoor Living — Designed & Built in Nebraska',
  phone: '(402) 202-9111',
  phoneHref: 'tel:+14022029111',
  email: 'sales@nebraskabackyardliving.com',
  serviceArea: 'Omaha & Lincoln Greater Metropolitan Area',
  years: '22',
  rating: 'A+ BBB Rating',
  baseUrl: 'https://nebraskabackyardliving.com',
};

const WIX = 'https://static.wixstatic.com/media';
const wix = (id) => `${WIX}/4791b7_${id}~mv2.png/v1/fill/w_1600,h_1067,al_c,q_85,enc_auto/4791b7_${id}~mv2.png`;

export const IMAGES = {
  hero: {
    src: wix('7397e82ba556466f9494663da7f3b03c'),
    alt: 'Custom outdoor kitchen and fire pit with illuminated pergola at dusk — Nebraska Backyard Living',
  },
  kitchen: {
    src: wix('b741716416c3481ab99c245709506ddd'),
    alt: 'Custom outdoor kitchen with stone bar seating and built-in grill — Nebraska Backyard Living',
  },
  firePit: {
    src: wix('378b63e3bb60421e8dfd8dff5cdb3bd1'),
    alt: 'Circular paver patio with stone fire pit and seating — Nebraska Backyard Living',
  },
  waterFeature: {
    src: wix('222e6aace96044eba04798a4c56a35ec'),
    alt: 'Natural stream water feature with boulders and lavender plantings — Nebraska Backyard Living',
  },
  patio: {
    src: wix('398d4662cc3a4b688c115ba697631c6f'),
    alt: 'Paver patio with fire table, lounge seating, and covered pavilion — Nebraska Backyard Living',
  },
  deck: {
    src: wix('e9b771e0ffc44eee92fe1f85f2e441bc'),
    alt: 'Custom cedar deck with metal balusters and lounge seating — Nebraska Backyard Living',
  },
  sunroom: {
    src: wix('1fa644e42eb941db9c45bc34e345deb5'),
    alt: 'Custom sunroom with floor-to-ceiling windows — Nebraska Backyard Living',
  },
  enclosure: {
    src: wix('ebb2b4502ec6452e83292effc1c0b96b'),
    alt: 'Custom patio enclosure with glass walls and lounge furniture — Nebraska Backyard Living',
  },
  pergola: {
    src: 'https://images.unsplash.com/photo-1781004896692-e662dc20fe24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBwZXJnb2xhJTIwYmFja3lhcmR8ZW58MHx8fHwxNzg3NjAzMjkyfDA&ixlib=rb-4.1.0&q=85',
    alt: 'Modern backyard pergola with warm string lights over an outdoor seating area',
  },
  pergolaModern: {
    src: 'https://images.pexels.com/photos/33287940/pexels-photo-33287940.jpeg?auto=compress&cs=tinysrgb&w=1600',
    alt: 'Elegant pergola framing a relaxed outdoor lounge',
  },
  homeDusk: {
    src: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80',
    alt: 'Beautiful home exterior glowing at dusk with landscaped yard',
  },
  homeModern: {
    src: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=80',
    alt: 'Modern Nebraska-style home with clean landscaping',
  },
  garden: {
    src: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=1600&q=80',
    alt: 'Lush garden path lined with mature plantings and flowering shrubs',
  },
  lawn: {
    src: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=1600&q=80',
    alt: 'Freshly landscaped backyard with crisp lawn lines',
  },
  sunroom: {
    src: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1600&q=80',
    alt: 'Bright sun-filled room with large windows and comfortable seating',
  },
  home2: {
    src: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1600&q=80',
    alt: 'Suburban home with a welcoming backyard',
  },
  home3: {
    src: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1600&q=80',
    alt: 'Classic two-story home with established yard',
  },
};

export const PROCESS_STEPS = [
  {
    num: '01',
    title: 'Consultation',
    text: 'We start at your home, listening to how you want to live outdoors. You get honest guidance, a clear scope, and a free, no-pressure consultation.',
  },
  {
    num: '02',
    title: 'Design & Planning',
    text: 'A custom design shaped around your property, your style, and your budget — with transparent pricing before any work begins.',
  },
  {
    num: '03',
    title: 'Build',
    text: 'Our experienced craftspeople build with premium materials and meticulous attention to detail, keeping you informed at every stage.',
  },
  {
    num: '04',
    title: 'Enjoy Your New Outdoor Space',
    text: 'Walk through the finished project with us, then start making memories in a backyard built to stand up to Nebraska seasons.',
  },
];

export const NAV_SERVICES_LABEL = 'Services';
